import { zonoApi } from '../api/zonoApi';
import { AgentSettingsState, updateAgentSettings } from './config.slice';

interface AgentSettingsRequest {
  sellerWorkspaceId: string;
}

export const agentSettingsApi = zonoApi.injectEndpoints({
  endpoints: (builder) => ({
    getAgentSettings: builder.query<AgentSettingsState, AgentSettingsRequest>({
      query: ({ sellerWorkspaceId }) => ({
        url: `hub/bot/api/v1/agent-settings/${sellerWorkspaceId}`,
        method: 'GET',
        params: {
          sellerWorkspaceId,
          includeTasks: true,
        },
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(updateAgentSettings(data));
        } catch {
          dispatch(updateAgentSettings(null));
        }
      },
    }),
  }),
});

export const { useLazyGetAgentSettingsQuery } = agentSettingsApi;
